import { ref, watch, Ref } from 'vue';
import { useTask } from '@/ui/concerns';
import { list as getEntityTypeProperties } from '@/services/api/resources/entityTypeProperty/actions';
import { isEntityPropertiesEnabled } from '@/ui/helpers/featureHelper';
import { EntityTypeProperty } from '@/entities/entityTypeProperty';

export function useEntityTypePropertiesLoader(entityTypeId: Ref<number | null>) {
  const entityTypeProperties = ref<EntityTypeProperty[]>([]);
  const entityTypeIdForProps = ref<number | null>(null);

  const loadPropsTask = useTask(
    () => getEntityTypeProperties(entityTypeIdForProps.value as number),
    result => {
      if (result && result.data) {
        entityTypeProperties.value = result.data;
      }
    },
  );

  const loadEntityTypeProperties = (typeId: number) => {
    if (!isEntityPropertiesEnabled()) {
      return;
    }

    entityTypeIdForProps.value = typeId;
    loadPropsTask.run();
  };

  watch(() => entityTypeId.value, newValue => {
    if (newValue) {
      loadEntityTypeProperties(newValue);
    } else {
      entityTypeProperties.value = [];
    }
  });

  return {
    entityTypeProperties,
    loadEntityTypeProperties,
  };
}
